import { useParams } from 'react-router-dom';
import { useAccountParam } from 'hooks';

type PaymentParams = {
    accountId: string,
    vendorId: string,
    paymentId: string,
};

export default function usePaymentParams() : PaymentParams {   
    const accountId = useAccountParam();
    const { vendorId, paymentId } = useParams() as PaymentParams;
    return { accountId, vendorId, paymentId };
};